import { useContext } from "react";
import { AppContext } from "../Context/AppContext";

const SiteMap = (props) => {
	const { theme } = useContext(AppContext);
	return (
		<>
			<div className='site-map' style={{ height: `calc(100vh - ${5.5}em)` }}>
				{props.children}
			</div>
		</>
	);
};

export default SiteMap;
